<template>
  <div class="LineSegment"> 
    <div ref="container" class="LineSegment__container">
      <canvas id="visualisation"/>
    </div>
  </div> 
</template>

<script>

import gsap from "gsap"
import * as GeometryUtils from './jsm/utils/GeometryUtils.js'

export default {

  name: 'LineSegment',
  data: ()=>({
    ready: false
  }),
  mounted() {
    // this.init()
  },

  methods: {

    init() {

      const canvas = document.getElementById( "visualisation" )
      const bounds = this.$refs.container.getBoundingClientRect()

      let scene = new THREE.Scene()
      let camera = new THREE.PerspectiveCamera( 75, bounds.width / bounds.height, 1, 1000 )
          camera.position.z = 30
          camera.aspect = bounds.width / bounds.height
          camera.updateProjectionMatrix()

      let renderer = new THREE.WebGLRenderer( { antialias: true, canvas: canvas, alpha: true } )
          renderer.setPixelRatio( window.devicePixelRatio )
          renderer.setSize( bounds.width, bounds.height )
          renderer.setClearColor( 0xdb2000, 0)

      let ambientLight = new THREE.AmbientLight( 0x000000 )
            scene.add( ambientLight )

      const positions = []
      const colors = []
      const points = GeometryUtils.hilbert3D( new THREE.Vector3( 0, 0, 0 ), 10.0, 1, 0, 1, 2, 3, 4, 5, 6, 7 )

      const spline = new THREE.CatmullRomCurve3( points )
      const divisions = Math.round( 40 * points.length )
      const point = new THREE.Vector3()
      const color = new THREE.Color()

      for ( let i = 0, l = divisions; i < l; i ++ ) {
        const t = i / l
        spline.getPoint( t, point )
        positions.push( point.x, point.y, point.z )
        color.setHSL( t, 1.0, 0.5 )
        colors.push( color.r, color.g, color.b )
      }

      const geometry = new THREE.LineGeometry()
            geometry.setPositions( positions )
            geometry.setColors( colors )

      let matLine = new THREE.LineMaterial( {
        color: 0xffffff,
        linewidth: 5, 
        vertexColors: true,
      })

      let line = new THREE.Line2( geometry, matLine )
          line.computeLineDistances()
          line.scale.set( 1, 1, 1 )
      scene.add( line )

      // const geo = new THREE.BufferGeometry()
      //       geo.setAttribute( 'position', new THREE.Float32BufferAttribute( positions, 3 ) )
      //       geo.setAttribute( 'color', new THREE.Float32BufferAttribute( colors, 3 ) )

      let render = ()=> {
        requestAnimationFrame( render )       
        matLine.resolution.set( bounds.width, bounds.height )
        const time = - performance.now() * 0.0003;
        renderer.render( scene, camera )
      }

      this.$nextTick(()=>{
        render()
      })  
    },
   
  }

}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.LineSegment
  
  width 100%
  height 45%
  position relative
  display flex 
  align-items center
  justify-content center
  border 1px solid red

  position absolute

  &__container 
    position relative
    width 100%
    height 100%
    display flex 
    align-items center
    justify-content center
    // background purple

  & img
    // height 100%
    // width 80% !important
    // height 43%
    width 300px !important
    height 300px

#visualisation
  height 100%
  background transparent
  border none

</style>


